import { c as _c } from "react/compiler-runtime";
import { Leaf } from "lucide-react";
import { DismissButton } from "@/components/chat/DismissButton";
interface ContextualCardProps {
  stepKey: string;
  stepPrompt: string;
  position: string;
  dismissLabel: string;
  ctaLabel: string;
  onOpen: () => void;
  onDismiss: (e: React.MouseEvent) => void;
}

/**
 * Contextual suggestion card shown on funnel pages.
 *
 * Displays a step-specific question (e.g. "Was ist die UNB?") that updates
 * on each step navigation. Dismissable to collapse into CompactCircle.
 */
export function ContextualCard(t0) {
  const $ = _c(20);
  const {
    stepKey,
    stepPrompt,
    position,
    dismissLabel,
    ctaLabel,
    onOpen,
    onDismiss
  } = t0;
  const t1 = `fixed ${position} z-[60] cursor-pointer
        animate-in slide-in-from-bottom-4 fade-in duration-500`;
  let t2;
  if ($[0] !== dismissLabel || $[1] !== onDismiss) {
    t2 = <DismissButton onClick={onDismiss} label={dismissLabel} />;
    $[0] = dismissLabel;
    $[1] = onDismiss;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="w-8 h-8 rounded-[9999px] shrink-0 bg-secondary-fixed/20 flex items-center justify-center"><Leaf className="w-3.5 h-3.5 text-secondary-fixed" /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== stepPrompt) {
    t4 = <p className="text-sm font-extrabold leading-snug">{stepPrompt}</p>;
    $[4] = stepPrompt;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== ctaLabel) {
    t5 = <span className="inline-flex items-center gap-1 bg-secondary-fixed/10 text-secondary-fixed text-[10px] font-bold px-2 py-1 rounded-full uppercase tracking-wider">{ctaLabel} →</span>;
    $[6] = ctaLabel;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = <div className="flex items-start gap-4">{t3}<div className="space-y-3">{t4}{t5}</div></div>;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t6) {
    t7 = <div className="group relative glass-dark text-white rounded-2xl px-5 py-4 max-w-[280px] chat-widget-hover">{t2}{t6}</div>;
    $[11] = t2;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== onOpen || $[15] !== stepKey || $[16] !== stepPrompt || $[17] !== t1 || $[18] !== t7) {
    t8 = <div key={stepKey} onClick={onOpen} role="complementary" aria-label={stepPrompt} className={t1}>{t7}</div>;
    $[14] = onOpen;
    $[15] = stepKey;
    $[16] = stepPrompt;
    $[17] = t1;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}